import { IAdminDeletedImageListItem } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

//어드민 - 삭제된 이미지 리스트 페이지: 테이블에 보여줄 리스트 데이터
async function getAdminDeletedImageList(
  page: number
): Promise<AxiosResponse<FetchResult<IAdminDeletedImageListItem[]>>> {
  const response = await instance.get(`/images/deleted?page=${page}&take=15`);
  return response;
}

const useFetchAdminDeletedImageList = (page: number) => {
  const { data: originalData, refetch } = useQuery({
    queryKey: ['get', `/images/deleted?page=${page}&take=15`],
    queryFn: () => getAdminDeletedImageList(page),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(page)
  });

  const response = originalData?.data;

  return { response, refetch };
};

export default useFetchAdminDeletedImageList;
